import {
  makeVRImagePlaneComponent,
  vrImagePlaneComponentType,
} from '@/_models/virtualStaging/VRImagePlane/component/VRImagePlane.component';
import { VRImagePlaneInputs } from '@/_models/virtualStaging/VRImagePlane/component/vrImagePlaneTypes';

const initVRImagePlaneObject = async (options: Partial<VRImagePlaneInputs>, showcaseTemp) => {
  try {
    await showcaseTemp.showcase.Scene.register(
      vrImagePlaneComponentType,
      makeVRImagePlaneComponent,
    );
    const modelNode: any = await showcaseTemp.mpSDK.Scene.createNode();
    const component = await modelNode.addComponent(vrImagePlaneComponentType, options);
    await modelNode.start();
    return [modelNode, component];
  } catch (e) {
    console.error(e);
    return [];
  }
};

/**
 * VR Image Plane that displays an image in front of the user in VR
 * - Can be toggled on/off
 * - Positioned relative to camera
 * - Always faces the user (billboard effect)
 */
export class VRImagePlane {
  public component: any = null;
  private imagePlaneNode: any = null;
  private isVisible = false;
  private showcaseTemp: any;
  private imageUrl: string;

  constructor(showcaseTemp: any, imageUrl: string) {
    this.showcaseTemp = showcaseTemp;
    this.imageUrl = imageUrl;
  }

  async init() {
    const options: Partial<VRImagePlaneInputs> = {
      position: { x: 0, y: 0, z: 0 },
      rotation: { x: 0, y: 0, z: 0 },
      visible: false, // Start hidden
      imageUrl: this.imageUrl,
      scale: 1,
      planeWidth: 2,
      planeHeight: 1.5,
    };

    const [modelNode, component] = await initVRImagePlaneObject(options, this.showcaseTemp);
    this.imagePlaneNode = modelNode;
    this.component = component;

    return this;
  }

  show() {
    if (this.component) {
      this.component.setVisible(true);
      this.isVisible = true;
      console.log('VR Image Plane shown');
    }
  }

  hide() {
    if (this.component) {
      this.component.setVisible(false);
      this.isVisible = false;
      console.log('VR Image Plane hidden');
    }
  }

  toggle() {
    if (this.isVisible) {
      this.hide();
    } else {
      this.show();
    }
  }

  setImageUrl(imageUrl: string) {
    this.imageUrl = imageUrl;
    if (this.component) {
      this.component.setImageUrl(imageUrl);
    }
  }

  getIsVisible() {
    return this.isVisible;
  }

  destroy() {
    if (this.imagePlaneNode) {
      this.imagePlaneNode.stop();
    }
  }
}
